module.exports = __webpack_public_path__ + "static/media/logo_header.f9c80ec9.svg";